// QRCodeScanner.js

import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const QRCodeScanner = ({ onExtractedData }) => {
  const location = useLocation();
  const history = useHistory();

  // State to store extracted data
  const [username, setUsername] = useState('');
  const [eventId, setEventId] = useState('');

  useEffect(() => {
    // Function to extract data from the URL
    const extractDataFromURL = () => {
      const searchParams = new URLSearchParams(location.search);
      const photographerName = searchParams.get('username');
      const eventId = searchParams.get('event');

      // Check if both username and event are present
      if (photographerName && eventId) {
        setUsername(photographerName);
        setEventId(eventId);
        onExtractedData({ username: photographerName, eventId });
      } else {
        // Handle invalid URL or missing parameters, e.g., redirect to an error page
        history.push('/error');
      }
    };

    // Call the function to extract data
    extractDataFromURL();
  }, [location.search, history, onExtractedData]);

  // You can render a loading indicator while extracting data
  if (!username || !eventId) {
    return <p>Loading...</p>;
  }

  // Render your component with the extracted data
  return (
    <div>
      <h2>QR Code Scanner</h2>
      <p>Username: {username}</p>
      <p>Event ID: {eventId}</p>
      {/* You can render additional content or components here */}
    </div>
  );
};

export default QRCodeScanner;
